import api from "../../../../api";
import React, { useState } from "react";
import values from "../../../../values";
import Context from "../../../../context";

import * as Yup from "yup";

import { useFormik } from "formik";
import { useQuery } from "react-query";
import { ICreateAndUpdateTicket } from "../../../../types/common.interface";
import {
  CustomButton2,
  CustomCheckBox,
  CustomIcon,
  CustomInput,
  CustomModal,
  CustomView,
  ImageUploader,
} from "../../../../components";

import "./index.scss";
import validations from "../../../../validations";
import utils from "../../../../utils";
import TitleLine from "../../../../components/TitleLine";
import { uploadImage } from "../../../../api/method.post/common";
import { useTranslation } from "react-i18next";

const Create = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, createFunction } = React.useContext(
    Context.TicketScreen
  );

  const [message, setMessage] = React.useState<any>("");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedImages, setSelectedImages] = React.useState<
    { link: string }[]
  >([]);

  const [access, setAccess] = useState<any>({
    financial: false,
    write: false,
  });

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------

  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------

  const formik = useFormik<ICreateAndUpdateTicket>({
    enableReinitialize: true,
    initialValues: {
      subject: "",
    },
    onSubmit: (values: ICreateAndUpdateTicket, { setSubmitting }) => {
      const formValues: ICreateAndUpdateTicket = {
        ...values,
        text: message,
        photo: selectedImages.map((item) => item.link),
      };

      console.log(formValues);
      Promise.resolve(createFunction(formValues))
        .then(() => {
          formik.resetForm();
        })
        .catch((e) => setSubmitting(false));
    },
  });

  const submitHandler = () => {
    formik.submitForm();
  };

  async function onUploadImage(imageFile: File) {
    const imagePromise = await uploadImage!(imageFile);
    if (imagePromise?.CODE === 2042)
      setSelectedImages([...selectedImages, imagePromise?.result]);
  }

  async function onSentTicket() {
    if (!message) return utils.errorHandler(8002);
    // if (message.length <= 10) return utils.errorHandler(8003);
    // const photo = selectedImages.map((item) => item.link);
    // const result = replyTicketFunction({
    //   text: message,
    //   _id: selectedTicket?._id,
    //   photo,
    // });
    // if (result) {
    //   refetchTickets();
    //   setSelectedImages([]);
    //   setMessage("");
    // }
  }
  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                               JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="super-agent-create-modal-container">
      <CustomIcon
        icon="fa-sharp fa-solid fa-circle-plus"
        size="medium"
        onClick={() => {
          setShowModal("CREATE");
        }}
      />
      <form onSubmit={submitHandler} id="create-user-modal">
        <CustomModal
          onClose={() => setShowModal("NONE")}
          open={showModal === "CREATE"}
          maxWidth={"39rem"}
          minWidth={"35rem"}
          maxHeight={"85vh"}
        >
          <div className="ticket-response">
            <CustomView.Column medium={12} className="form-colum">
              <CustomInput
                name="subject"
                id="subject"
                label={t("title")}
                value={formik.values.subject}
                onValueChange={formik.handleChange}
                formikProps={{ onBlur: formik.handleBlur }}
                error={formik.errors.subject && formik.touched.subject}
                errorText={formik.errors.subject}
              />
            </CustomView.Column>
            <label>
              <div>{t("text")}</div>
              <textarea
                onChange={(event) => setMessage(event.target.value)}
                value={message}
              ></textarea>
            </label>
            <div className="images-container">
              {selectedImages?.map((item) => (
                <ImageUploader
                  defaultImage={item}
                  setImage={() => setSelectedImages([...selectedImages, item])}
                  uploadImage={(event: any) => onUploadImage(event)}
                  label=""
                  onRemoveImage={(image: string) =>
                    setSelectedImages(
                      selectedImages.filter((item) => item?.link !== image)
                    )
                  }
                />
              ))}
              <ImageUploader
                defaultImage={undefined}
                setImage={() => false}
                uploadImage={(event: any) => onUploadImage(event)}
                label=""
              />
            </div>

            <div className="send-button">
              <CustomButton2
                isLoading={isLoading}
                title={t("submit")}
                onClick={submitHandler}
              />
            </div>
            {/* <TitleLine title="تیکت ها" /> */}
          </div>

          {/* <div className="ticket-conversation">
            <ul className="ticket-conversation-container">
              {selectedTicket?.ticket
                // ?.slice()
                // .reverse()
                .map((ticket: any, index: number) =>
                  ticket?.isAdmin ? (
                    <li
                      className="ticket-conversation-item question"
                      key={index}
                    >
                      <div className="ticket-conversation-title">
                        <div>کارشناس سنجد</div>
                        <div>
                          {utils.convertGregorianToJalali({
                            date: ticket?.selectedTicket,
                            format: " h:m - jYYYY/jMM/jDD",
                          })}
                        </div>
                      </div>
                      <div className="ticket-conversation-body">
                        {ticket?.text}
                        <div className="response-images-container">
                          {ticket?.photo?.map((item: string) => (
                            <div>
                              <ImageViewer imageUrl={item} />
                            </div>
                          ))}
                        </div>
                      </div>
                    </li>
                  ) : (
                    <li className="ticket-conversation-item answer">
                      <div className="ticket-conversation-title">
                        <div>{`${selectedTicket?.user?.firstName} ${selectedTicket?.user?.lastName}`}</div>
                        <div>
                          {utils.convertGregorianToJalali({
                            date: ticket?.selectedTicket,
                            format: " h:m - jYYYY/jMM/jDD",
                          })}
                        </div>
                      </div>
                      <div className="ticket-conversation-body">
                        <p>{ticket?.text}</p>
                      </div>
                    </li>
                  )
                )}
            </ul>
          </div> */}
        </CustomModal>
      </form>
    </section>
  );
};

export default Create;
